import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // 커스텀 폰트 사이즈 클래스들을 기존 font-size 그룹에 추가
      'font-size': [
        'text-title',
        'text-headline',
        'text-subheadline',
        'text-body',
        'text-label',
        'text-callout',
        'text-fontnote',
        'text-button1',
        'text-button2',
        'text-caption',
        'text-h1',
        'text-h2',
        'text-h3',
        'text-h4',
        'text-h5',
        'text-bodyLarge',
        'text-bodyMedium',
        'text-bodyNormal',
        'text-bodySmall',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return customTwMerge(clsx(inputs))
}
